import StatCard from "./StatCard";
import styles from "./StatCardsParent.module.css";

// dataItems: array of { label, value, color }
const StatCardsParent = ({
  title = "Risk Indicators",
  dataItems = [],
  isLoading,
  containerProps = {},
  skeletonCount = 4,
  ...rest
}) => {
  return (
    <div
      {...containerProps}
      className={[styles.container, containerProps?.className].join(" ")}
    >
      {title && <p className={styles.title}>{title}</p>}
      <div className={styles.grid}>
        {isLoading
          ? Array.from({ length: skeletonCount }).map((_, i) => (
              <StatCard key={i} isLoading />
            ))
          : dataItems.map((item) => (
              <StatCard
                key={item.label}
                label={item.label}
                value={item.value}
                color={item.color}
                onClick={item.onClick}
              />
            ))}
      </div>
    </div>
  );
};

export default StatCardsParent;
